module.exports = __webpack_public_path__ + "img/fb.a8226707.png";